import { useRef } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
// UI

import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from '@chakra-ui/react'

import { useConfirmationModalManagement } from '@/stores/ui/confirmationModalSlice'

const ConfirmationModal = () => {
  // Redux
  const { confirm, decline, isInput, isOpened, message, inputLabel, title } = useConfirmationModalManagement()
  const formMethod = useForm()

  const textareaRef = useRef()
  const onSubmit = () => {
    confirm(textareaRef?.current?.value)
  }

  return (
    <Modal isOpen={isOpened} onClose={decline} size="xl">
      <FormProvider {...formMethod}>
        <form onSubmit={formMethod.handleSubmit(onSubmit)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{title || ''}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex direction="column" gap="2">
                <Text>{message}</Text>
              </Flex>
              {isInput && (
                <>
                  <Box paddingTop="4">
                    <Text>{inputLabel}:</Text>
                    <Textarea name="input" placeholder="Enter your input" defaultValue="" ref={textareaRef} />
                  </Box>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              <HStack>
                <Button colorScheme={'teal'} type="submit">
                  Yes
                </Button>
                <Button colorScheme="gray" onClick={decline}>
                  No
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </form>
      </FormProvider>
    </Modal>
  )
}

export default ConfirmationModal
